"use client"

type KlaviyoFormProps = {
    data: {
        _type: "klaviyoBlock"
        klavyoFormId?: string
    }
}

export default function KlaviyoForm({ data }: KlaviyoFormProps) {
    return (
        <section className="py-32 md:py-56">
            <div className={`px-16 py-6 klaviyo-form-${data.klavyoFormId}`}></div>
        </section>
    )
}
